import { useNavigate } from "react-router-dom";
import { useCompanyStore } from "@/Store";

interface NotificationTarget {
  link?: string | null;
  companyId?: number | null;
}

// Notificações são multiempresa (user-scoped). Ao abrir uma, trocamos o contexto
// para a empresa dona da notificação antes de navegar para o link (que aponta
// para páginas escopadas por empresa).
export const useNotificationNavigate = () => {
  const navigate = useNavigate();
  const currentCompanyId = useCompanyStore((state) => state.currentCompanyId);
  const setCurrentCompanyId = useCompanyStore(
    (state) => state.setCurrentCompanyId
  );

  return (item: NotificationTarget) => {
    if (item.companyId && item.companyId !== currentCompanyId) {
      setCurrentCompanyId(item.companyId);
    }
    if (item.link) navigate(item.link);
  };
};
